import React, {Fragment} from 'react';
import PageTitle from '../../components/pagetitle/PageTitle'
import ServiceSectionS3 from '../../components/ServiceSectionS3/ServiceSectionS3';
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
import Navbar2 from '../../components/Navbar2/Navbar2';
import CtaSection from '../../components/ctaSection/ctaSection';
import img from '../../images/page-title.jpg';

const ServicePage =() => {

    return(
        <Fragment>
            <Navbar2 hclass={'wpo-header-style-1'} />
            <PageTitle pageTitle={'Service'} pagesub={'Service'} img={img}/> 
            <ServiceSectionS3/>
            <CtaSection/>   
            <Footer/>
            <Scrollbar/>
        </Fragment>
    )
};
export default ServicePage;

